import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  address: PropTypes.shape({
    line1: PropTypes.string,
    line2: PropTypes.string,
    city: PropTypes.string,
    region: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    postal: PropTypes.string,
  }),
};

class FormattedAddress extends Component {
  render() {
    const { address, style, ...otherProps } = this.props;
    const styles = {
      display: 'block',
      padding: 0,
      ...style,
    };

    return (
      <address className="FormattedAddress" style={styles} {...otherProps}>
        {address.line1}
        <br />
        {address.line2 && (
          <Fragment>
            {address.line2}
            <br />
          </Fragment>
        )}
        {address.city}, {address.region.code} {address.postal}
      </address>
    );
  }
}

FormattedAddress.propTypes = propTypes;

export default FormattedAddress;
